import * as Sentry from '@sentry/react';
Sentry.init({
  dsn: 'https://c2fdb738df6f92ffee82ab4d8e7af2d2@sentry-prod.mmtwork.com/20',
  integrations: [
    // new Integrations.BrowserTracing(),
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],

  // Performance Monitoring
  tracesSampleRate: 1, // 生产环境使用 100% 采样率，不需要控制成本
  // 配置分布式追踪的目标域名
  // tracePropagationTargets: [
  //   'localhost',
  //   /^https:\/\/office(-dev)?\.momenta\.cn\//, // 匹配测试和生产环境的 API
  // ],

  // Session Replay 配置
  replaysSessionSampleRate: 0.2, // 正常情况下 20% 的会话录制率，获得更多用户行为数据
  replaysOnErrorSampleRate: 1.0, // 错误发生时 100% 录制，便于问题排查
});
